import Axios from 'axios'
import store from '../store'
//引入antdUI框架
import { Message } from 'element-ui';

let refresh_token = false,
    requests = [];

// 用refresh_token获取有效token
function getTokenByRefreshToken() {
    // new-刷新token  -接口-/userLogin/getRefreshToken
    return Axios.get(`${process.env.baseURL}/userLogin/getRefreshToken`, {})
}
Axios.defaults.withCredentials = true
// http request 请求拦截器
Axios.interceptors.request.use(config => {

	let matched = config.url.match(/userLogin\/adminLogin$/g) || [];
	let matchedToken = config.url.match(/userLogin\/getRefreshToken$/g) || [];
	
    if (config.responseType) {
        config.headers['responseType'] = 'arraybuffer';
    }
    if (config.url && matched.length>0 && config.data.grantType == 'password') {
		//登录认证
        config.auth = {username: config.data.username, password: config.data.password};
    } else if (config.url &&  matchedToken.length>0 ) {
		//用于刷新token
        config.headers['refreshToken'] = `${localStorage.getItem('REFRESH_TOKEN')}`;
    } else {
        if(config.url && (config.url.match(/userLogin\/createCompany$/g) || []).length == 0){
			//添加token
            config.headers['Authorization'] = `${localStorage.getItem('X_TOKEN')}`;
        }
	}

	// old-在发送请求之前做些什么
	// let pathname = location.pathname;
	// const token = store.state.token;
	// if (config.data && config.data.grant_type && config.data.grant_type == 'refresh_token') {
	// 	config.headers['Authorization'] = `${store.state.refreshToken}`;
	// 	return config;
	// }
	// if(token){
	// 	if(pathname != '/' &&  pathname != '/login'){
	// 		config.headers.common['Authorization'] = `${token}`;
	// 	}
	// }
	return config;
}, error => {
	// 对请求错误做些什么
	return Promise.reject(error);
});

// http response 响应拦截器
Axios.interceptors.response.use(response => {
  const { code,msg }=response.data;
   //token过期--40001-处理如下：
   if ( code ==40001&&!response.config.responseType){
		let test =null;
		if(!refresh_token){
			refresh_token = true;//这里-若接口异常-只调用一次刷新接口
			getTokenByRefreshToken().then((resToken) => {
				// refresh_token = false;//这里-若接口异常-一直获取不到token-产生死循环
				//注意：刷新token的接口不稳定，所此处设置了false有可能会产生死循环！所以刷新token接口目前只调用一遍！
				localStorage.setItem('X_TOKEN', resToken.data.access_token);
				requests.map(cb=>cb(resToken.data.access_token))
				requests = [];
			}).catch(err=>{
				console.log(err);
			});
			 test = new Promise((resolve=>{
				requests.push((token)=>{
					console.log(token)
					response.config.headers.Authorization = `${token}`;
					resolve(Axios(response.config))
				})
			}))
		}
		return test;
	} 
	if ( code ==40002){
		// REFRESH_TOKEN过期-跳转登录页面
		Message.warning('登录超时，请重新登录');
		localStorage.clear();
		store.commit('INITE_STATE');
		let url = window.location.href;
        window.location.replace(url) ;
		return null;
	}	
	//其它结果-处理
	if (code == 400 || code == 401 || code == 4001 || code==4100 ||code==4011){
		// Message.error('登陆失效');
		localStorage.clear();
		setTimeout(() => {
			store.commit('SET_LOGIN',true);
			let url = window.location.href;
        	window.location.replace(url) ;
		}, 1000);
		return response.data;
	}
	if(code!=1){
		Message.error(msg);
		// return response.data;
	}
 	return response.data;
},async (error) => {
	// console.log(error, error.response,'errorInfo')
 	if (error.response) {
		if (error.response.status==401) {
			let code = error.response.data.code;
			let request_config = error.config;
			if (code == 401) {
				const res=await getTokenByRefreshToken()
				localStorage.setItem('X_TOKEN', res.data.access_token);
				store.commit('SET_TOKEN', res.data.access_token);
				request_config.headers.Authorization = `${res.data.access_token}`;
				const newData=await Axios(request_config);
				return newData;
			}
			//refresh_token失效
			if (code == 4001) {
				localStorage.clear();
				setTimeout(() => {
					store.commit('SET_LOGIN', true);
					let url = window.location.href;
        			window.location.replace(url) ;
				}, 1000);
			}
		}else{
			Message.error(error.response.data.msg);
			// 返回接口返回的错误信息
			return error.response.data;
			// return Promise.reject(error.response.data);
		}
		// 返回接口返回的错误信息
		// return Promise.reject(error.response.data);
	}
});

export default Axios;



// WEBPACK FOOTER //
// ./src/apis/ajax.js